import {get, createSelector} from 'helpers';
import {byLocalMark, dispatch} from 'store/goals';
import {category} from 'store/common';
import {linkGoalActivities} from './actions';

const goal = createSelector(
  [byLocalMark, category],
  (byLocalMark, category) => byLocalMark['clarity-' + category],
)

export const goals = createSelector(
  [goal, category],
  (goal, category) => ({
    id: goal?.id,
    name: goal?.name ?? '',
    update: (value?: string) => {
      if (value) {
        dispatch.upsert({
          ...goal,
          localMark: `clarity-${category}`,
          name: value,
          category,
        })
      } else if (goal) {
        dispatch.remove(goal);
      }
      linkGoalActivities(category);
    }
  }),
);
